import { mapGetters, mapMutations } from 'vuex';
import organizationMemberService from './../../../../services/organizationMember';

export default {
  data: () => ({ 
    newMemberForm: {
      firstname: '',
      lastname: '',
      email: '',
    },
    newMemberRules: {
      firstname: [
        { required: true, trigger: 'blur' },
      ],
      lastname: [
        { required: true, trigger: 'blur' },
      ],
      email: [
        { required: true, trigger: 'blur' },
        { type: 'email', trigger: 'blur' }
      ],
    },
  }),
  
  computed: {
    ...mapGetters({
      organization_members: 'allOrganizationMembers',
    }),
  },

  methods: {
    ...mapMutations({
      toggle: 'TOGGLE_MODAL',
      unsetModalContent: 'UNSET_MODAL_CONTENT',
    }),

    addMember() {
      this.$refs['newMemberForm'].validate((valid) => {
        if (valid) {
          // check if email already exists
          var exists = this.organization_members.findIndex(x => x.user.email == this.newMemberForm.email.trim());
          if (exists > -1) {
            this.$message({
              message: 'Member already exists',
              type: 'error',
            });
          } else {
            organizationMemberService.store(this.newMemberForm).then(() => {});
            this.closeModal();
          }
        }
      });
    },

    closeModal() {
      this.toggle(false);
      this.unsetModalContent();
    },
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/withNavigation/members/create/create.js